import React from 'react';
import {useEffect} from 'react';
import {useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';

import {
  getAccessToken,
  getOrderResp,
  getPhoneNumber,
  getUser,
} from '../../core/localstorage-data';

import {gtmRewardPoint} from '../../lib/tagmanager';
import {
  customerProfile,
  fetchCustomerProfile,
} from '../../redux/customerSearchSlice';
import {useDispatch} from 'react-redux';
export const Rewardspoints = () => {
  const [points, setPoints] = useState(0);
  const [name, setName] = useState('');
  const [font, setFont] = useState(false);
  const date = new Date();
  const year = date.getFullYear();
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const dispatch = useDispatch();
  const orderResp = getOrderResp();

  const customerProfileData = useAppSelector(customerProfile);
  useEffect(() => {
    gtmRewardPoint(customerProfileData);
    const sampleToken = getAccessToken();
    const phoneNumber = getPhoneNumber();
    if (sampleToken) {
      const parameters = {
        payload: {
          source: 'MAXBUDDY',
          locationCode: 'BNG',
          mobileNumber: phoneNumber,
          orderId: orderResp.orderId,
        },
        accessToken: sampleToken,
      };

      dispatch(fetchCustomerProfile(parameters));
    }
  }, []);
  useEffect(() => {
    if (customerProfileData.firstName != null) {
      const customerPoints = customerProfileData.pointsAvailable * 0.6;
      setPoints(customerPoints);
    }
  }, [customerProfileData]);
  useEffect(() => {
    if(customerProfileData.lastName===null)
    {
      setName(customerProfileData.firstName);
    }
    else{
      const fullName = customerProfileData.firstName+' '+customerProfileData.lastName;
      setName(fullName);
    }
    


    const pointsLength = customerProfileData.pointsAvailable * 0.6;
    const length = pointsLength.toString().length;
    if (length > 3) {
      setFont(true);
    } else {
      setFont(false);
    }
  }, [points]);

  return (
    <div className="h-17 w-71 grid place-items-center   font-roboto">
      <div>
        <p className="text-base text-center font-normal mt-6">
          {day}-{month}-{year}
        </p>
        <p className="text-xl font-medium">{name}</p>
      </div>
      <div className="table mt-5">
        <div className="align-middle border-8 border-royal_blue h-36 p-6 rounded-full table-cell text-center w-36">
          {font === true ? (
            <div className="text-xl">
              {'\u20B9'} {points.toFixed(2)}
            </div>
          ) : (
            <div className="text-4xl">
              {'\u20B9'} {points.toFixed(2)}
            </div>
          )}

          {/* <div className=" text-base text-royal_blue">POINTS</div> */}
        </div>
      </div>
    </div>
  );
};
